import MojitoPresentation from 'mojito/presentation';
import SingleLeagueCouponTypes from './types.js';
import EventsCoupon from 'modules/events-coupon/index.js';
import { useOutletContext } from 'applications/common/routing/outlet-context.js';

const { FlexPane } = MojitoPresentation.Components;
const { COUPONS } = SingleLeagueCouponTypes;

export default function SingleLeagueCoupon(props) {
    const {
        mojitoTools: {
            config,
            stringResolver,
            appContext: { subscriptionResolver },
        },
    } = props;

    const { sportId, typeId, pageType, onDataLoad } = useOutletContext();
    const isOutrights = pageType === COUPONS.OUTRIGHTS;
    const eventGroupsId = isOutrights
        ? subscriptionResolver.allOutrightEvents(typeId)
        : subscriptionResolver.allMatchEvents(typeId);

    const resolveHeaderText = (eventGroups = []) => {
        return isOutrights
            ? stringResolver.resolveString('$SINGLE_LEAGUE_COUPON.OUTRIGHTS')
            : eventGroups[0]?.typeName;
    };

    return (
        <FlexPane config={config.container} class={'ta-SingleLeagueCoupon'}>
            <EventsCoupon
                sportId={sportId}
                eventGroupsId={eventGroupsId}
                headerText={resolveHeaderText}
                config={config.eventsCoupon}
                isInPlay={false}
                analyticsName="Single League Coupon"
                onDataLoad={onDataLoad}
                isOutrights={isOutrights}
            />
        </FlexPane>
    );
}
